function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import $ from 'dom7';
import { window } from 'ssr-window';
import Utils from '../../utils/utils';
import Modal from '../modal/modal-class';

var Toast = /*#__PURE__*/function (_Modal) {
  _inherits(Toast, _Modal);

  var _super = _createSuper(Toast);

  function Toast(app, params) {
    var _this;

    _classCallCheck(this, Toast);

    var extendedParams = Utils.extend({
      on: {}
    }, app.params.toast, params); // Extends with open/close Modal methods;

    _this = _super.call(this, app, extendedParams);

    var toast = _assertThisInitialized(_this);

    toast.app = app;
    toast.params = extendedParams;
    var _toast$params = toast.params,
        closeButton = _toast$params.closeButton,
        closeTimeout = _toast$params.closeTimeout;
    var $el;

    if (!toast.params.el) {
      // Find Element
      var toastHtml = toast.render();
      $el = $(toastHtml);
    } else {
      $el = $(toast.params.el);
    }

    if ($el && $el.length > 0 && $el[0].f7Modal) {
      return _possibleConstructorReturn(_this, $el[0].f7Modal);
    }

    if ($el.length === 0) {
      return _possibleConstructorReturn(_this, toast.destroy());
    }

    Utils.extend(toast, {
      $el: $el,
      el: $el[0],
      type: 'toast'
    });
    $el[0].f7Modal = toast;

    if (closeButton) {
      $el.find('.toast-button').on('click', function () {
        toast.emit('local::closeButtonClick toastCloseButtonClick', toast);
        toast.close();
      });
      toast.on('beforeDestroy', function () {
        $el.find('.toast-button').off('click');
      });
    }

    var timeoutId;
    toast.on('open', function () {
      $('.toast.modal-in').each(function (index, openedEl) {
        var toastInstance = app.toast.get(openedEl);

        if (openedEl !== toast.el && toastInstance) {
          toastInstance.close();
        }
      });

      if (closeTimeout) {
        timeoutId = Utils.nextTick(function () {
          toast.close();
        }, closeTimeout);
      }
    });
    toast.on('close', function () {
      window.clearTimeout(timeoutId);
    });

    if (toast.params.destroyOnClose) {
      toast.once('closed', function () {
        setTimeout(function () {
          toast.destroy();
        }, 0);
      });
    }

    return _possibleConstructorReturn(_this, toast);
  }

  _createClass(Toast, [{
    key: "render",
    value: function render() {
      var toast = this;
      if (toast.params.render) return toast.params.render.call(toast, toast);
      var _toast$params2 = toast.params,
          position = _toast$params2.position,
          horizontalPosition = _toast$params2.horizontalPosition,
          cssClass = _toast$params2.cssClass,
          icon = _toast$params2.icon,
          text = _toast$params2.text,
          closeButton = _toast$params2.closeButton,
          closeButtonColor = _toast$params2.closeButtonColor,
          closeButtonText = _toast$params2.closeButtonText;
      var horizontalClass = position === 'top' || position === 'bottom' ? "toast-horizontal-".concat(horizontalPosition) : '';
      return "\n      <div class=\"toast toast-".concat(position, " ").concat(horizontalClass, " ").concat(cssClass || '', " ").concat(icon ? 'toast-with-icon' : '', "\">\n        <div class=\"toast-content\">\n          ").concat(icon ? "<div class=\"toast-icon\">".concat(icon, "</div>") : '', "\n          <div class=\"toast-text\">").concat(text, "</div>\n          ").concat(closeButton && !icon ? "\n          <a class=\"toast-button button ".concat(closeButtonColor ? "color-".concat(closeButtonColor) : '', "\">").concat(closeButtonText, "</a>\n          ").trim() : '', "\n        </div>\n      </div>\n    ").trim();
    }
  }]);

  return Toast;
}(Modal);

export default Toast;